/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";

const ESTADO_OPTS = [
  { v: "em_falta", label: "Em falta", color: "#ef4444", bg: "#fef2f2" },
  { v: "entregue", label: "Entregue", color: "#10b981", bg: "#ecfdf5" },
  { v: "nao_aplicavel", label: "Não aplicável", color: "#6b7280", bg: "#f3f4f6" },
];
const ESTADO_BUPI = [
  { v: "em_falta", label: "Em falta", color: "#ef4444", bg: "#fef2f2" },
  { v: "entregue", label: "Entregue", color: "#10b981", bg: "#ecfdf5" },
  { v: "georreferenciada_crp", label: "Georreferenciada na CRP", color: "#6366f1", bg: "#eef2ff" },
];
const TIPOS_IMOVEL_CHECKLIST = [
  { v: "habitacao", l: "Habitação" },
  { v: "comercio", l: "Comércio / Lojas / Serviços / Garagens / Armazéns / Arrumos" },
  { v: "terreno_urbano", l: "Terreno Urbano" },
  { v: "terreno_rustico", l: "Terreno Rústico" },
];
const TIPOS_TITULAR = [
  { v: "individual_nacional", l: "Individual Nacional" },
  { v: "estrangeiro", l: "Cidadão Estrangeiro" },
  { v: "heranca", l: "Herança" },
  { v: "empresa", l: "Empresa / Sociedade" },
];

const S = {
  input: { width: "100%", padding: "9px 12px", border: "1.5px solid #ece9e3", borderRadius: 8, fontSize: 13.5, fontFamily: "inherit", background: "#fff", outline: "none", color: "#1a1a2e" },
  inputSm: { width: "100%", padding: "7px 10px", border: "1.5px solid #ece9e3", borderRadius: 7, fontSize: 12.5, fontFamily: "inherit", background: "#fff", outline: "none", color: "#1a1a2e" },
  label: { fontSize: 11.5, fontWeight: 600, color: "#6b7280", marginBottom: 4, display: "block", textTransform: "uppercase", letterSpacing: "0.04em" },
  labelSm: { fontSize: 11, fontWeight: 600, color: "#6b7280", marginBottom: 3, display: "block", textTransform: "uppercase", letterSpacing: "0.04em" },
  g2: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 },
  g3: { display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12 },
};

function itemVazio(id, label, obrigatorio = true, recomendado = false, temNumero = false, temData = false, temValidade = false) {
  return { id, label, obrigatorio, recomendado, estado: "em_falta", numero: "", data: "", validade: "", ficheiros: [], temNumero, temData, temValidade };
}

function gerarChecklist(tipoImovel, tipoTitular, temFinanciamento) {
  const itens = [];

  // IDENTIFICAÇÃO
  if (tipoTitular === "individual_nacional") {
    itens.push(itemVazio("cc_nif", "Cartão de Cidadão / BI + NIF", true));
    itens.push(itemVazio("decl_nao_autorizacao", "Declaração de não autorização + cônjuges", true));
    itens.push(itemVazio("estado_civil_regime", "Estado civil + regime de casamento + naturalidades", true));
  } else if (tipoTitular === "estrangeiro") {
    itens.push(itemVazio("passaporte_titulo", "Passaporte / Título de Residência + NIF", true));
    itens.push(itemVazio("estado_civil_nat", "Estado civil + naturalidade + regime de casamento", true));
  } else if (tipoTitular === "heranca") {
    itens.push(itemVazio("docs_herdeiros", "Documentos identificação herdeiros + cônjuges", true));
    itens.push(itemVazio("decl_nao_aut_herdeiros", "Declaração de não autorização (herdeiros e cônjuges)", true));
    itens.push(itemVazio("hab_herdeiros", "Escritura(s) de Habilitação de Herdeiros", true));
    itens.push({ ...itemVazio("imposto_selo_obito", "Imposto de Selo (óbito há menos de 8 anos)", false), estado: "nao_aplicavel" });
  } else if (tipoTitular === "empresa") {
    itens.push(itemVazio("cert_permanente_empresa", "Código certidão permanente da empresa (válido)", true, false, true));
    itens.push(itemVazio("docs_signatarios", "Documentos identificação de quem assina", true));
    itens.push(itemVazio("rcbe", "RCBE – Registo Central do Beneficiário Efetivo", true));
  }
  itens.push({ ...itemVazio("procuracao", "Procuração (se aplicável)", false), tipo_procuracao: "", nome_procurador: "", estado: "nao_aplicavel" });

  // IMÓVEL
  if (tipoImovel === "habitacao") {
    itens.push(itemVazio("cpu", "Caderneta Predial Urbana (CPU)", true, false, true, true));
    itens.push(itemVazio("crp", "Certidão do Registo Predial (CRP)", true, false, true));
    itens.push({ ...itemVazio("licenca", "Licença de Utilização / Isenção / Simplex", true, false, true, true), tipo_licenca: "licenca" });
    itens.push({ ...itemVazio("ficha_tecnica", "Ficha Técnica de Habitação", false, true, false, true), estado: "nao_aplicavel" });
    itens.push({ ...itemVazio("deposito_ficha", "Depósito da Ficha Técnica na CM", false, true, false, true), estado: "nao_aplicavel" });
    itens.push({ ...itemVazio("cert_energetico", "Certificado Energético / Declaração de Dispensa", true, false, true, false, true), tipo_cert: "certificado" });
    itens.push({ ...itemVazio("plantas", "Plantas – Câmara Municipal", false), estado: "nao_aplicavel" });
    itens.push({ ...itemVazio("dir_preferencia", "Declaração Direito de Preferência", false, false, false, true), estado: "nao_aplicavel" });
    itens.push({ ...itemVazio("decl_condominio", "Declaração de Condomínio", false, false, false, true), estado: "nao_aplicavel" });
    itens.push({ ...itemVazio("decl_toponimica", "Declaração Toponímica", false, false, false, true), estado: "nao_aplicavel" });
  } else if (tipoImovel === "comercio") {
    itens.push(itemVazio("cpu", "Caderneta Predial Urbana (CPU)", true, false, true, true));
    itens.push(itemVazio("crp", "Certidão do Registo Predial (CRP)", true, false, true));
    itens.push({ ...itemVazio("licenca", "Licença de Utilização / Isenção / Simplex", true, false, true, true), tipo_licenca: "licenca" });
    itens.push({ ...itemVazio("cert_energetico", "Certificado Energético / Declaração de Dispensa", false, false, true, false, true), tipo_cert: "certificado", estado: "nao_aplicavel" });
    itens.push({ ...itemVazio("plantas", "Plantas – Câmara Municipal", false), estado: "nao_aplicavel" });
  } else if (tipoImovel === "terreno_urbano") {
    itens.push(itemVazio("cpu", "Caderneta Predial Urbana (CPU)", true, false, true, true));
    itens.push(itemVazio("crp", "Certidão do Registo Predial (CRP)", true, false, true));
    itens.push({ ...itemVazio("planta_loc", "Planta de localização / Levantamento topográfico", false), estado: "nao_aplicavel" });
  } else if (tipoImovel === "terreno_rustico") {
    itens.push(itemVazio("cpr", "Caderneta Predial Rústica", true, false, true, true));
    itens.push(itemVazio("crp", "Certidão do Registo Predial (CRP)", true, false, true));
    itens.push({ ...itemVazio("bupi", "BUPI", false), estado_bupi_opts: true, estado: "em_falta" });
    itens.push({ ...itemVazio("planta_loc", "Planta de localização / Levantamento topográfico", false), estado: "nao_aplicavel" });
  }

  // FINANCIAMENTO
  if (temFinanciamento) {
    itens.push({ ...itemVazio("distrate", "Pedido de Distrate", true, false, false, true), estado: "em_falta" });
    itens.push({ ...itemVazio("avaliacao_bancaria", "Avaliação Bancária", true, false, false, true), estado: "em_falta" });
  }

  return itens;
}

export default function ChecklistDocumentos({ supabase, formularioId, tipoImovelInicial, tipoTitularInicial, temFinanciamento, value, onChange, onTipoImovelChange, onTipoTitularChange, isLider }) {
  const [tipoImovel, setTipoImovel] = useState(tipoImovelInicial || "");
  const [tipoTitular, setTipoTitular] = useState(tipoTitularInicial || "individual_nacional");
  const [itens, setItens] = useState(value || []);
  const [aberta, setAberta] = useState(false);
  const [modoEditar, setModoEditar] = useState(false);

  useEffect(() => {
    if (tipoImovelInicial) setTipoImovel(tipoImovelInicial);
  }, [tipoImovelInicial]);

  useEffect(() => {
    if (tipoTitularInicial) setTipoTitular(tipoTitularInicial);
  }, [tipoTitularInicial]);

  useEffect(() => {
    if (tipoImovel && tipoTitular) {
      if (value && value.length > 0) {
        setItens(value);
      } else {
        const gerados = gerarChecklist(tipoImovel, tipoTitular, temFinanciamento);
        setItens(gerados);
        onChange(gerados);
      }
    }
  }, [tipoImovel, tipoTitular, temFinanciamento]);

  function handleTipoImovel(v) {
    setTipoImovel(v);
    setItens([]);
    onChange([]);
    if (onTipoImovelChange) onTipoImovelChange(v);
  }

  function handleTipoTitular(v) {
    setTipoTitular(v);
    setItens([]);
    onChange([]);
    if (onTipoTitularChange) onTipoTitularChange(v);
  }

  function updateItem(index, novoItem) {
    const novos = itens.map((it, i) => i === index ? novoItem : it);
    setItens(novos);
    onChange(novos);
  }

  const entregues = itens.filter(i => i.estado === "entregue" || i.estado === "georreferenciada_crp").length;
  const emFalta = itens.filter(i => i.estado === "em_falta" && i.obrigatorio).length;

  return (
    <div>
      <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", cursor:"pointer", padding:"8px 0" }} onClick={()=>setAberta(a=>!a)}>
        <div style={{ display:"flex", alignItems:"center", gap:8 }}>
          <span style={{ fontSize:13 }}>{aberta?"▾":"▸"}</span>
          <span style={{ fontSize:13, fontWeight:600, color:"#374151" }}>Ver lista de documentos necessários</span>
          {itens.length>0 && <span style={{ fontSize:11, background:"#f3f4f6", borderRadius:20, padding:"2px 8px", color:"#6b7280" }}>{itens.length} docs</span>}
        </div>
        {isLider && aberta && (
          <button onClick={e=>{ e.stopPropagation(); setModoEditar(m=>!m); }} style={{ fontSize:11, background: modoEditar?"#fef3c7":"#f3f4f6", color: modoEditar?"#92400e":"#6b7280", border:"none", borderRadius:6, padding:"3px 10px", cursor:"pointer", fontWeight:600 }}>
            {modoEditar?"✓ Terminar edição":"✏️ Editar lista"}
          </button>
        )}
      </div>
      {aberta && <div>
      {/* Seleção tipo imóvel e titular */}
      <div style={S.g2}>
        <div>
          <label style={S.label}>Tipo de Imóvel *</label>
          <select value={tipoImovel} onChange={e => handleTipoImovel(e.target.value)} style={S.input}>
            <option value="">Selecionar para gerar checklist...</option>
            {TIPOS_IMOVEL_CHECKLIST.map(t => <option key={t.v} value={t.v}>{t.l}</option>)}
          </select>
        </div>
        <div>
          <label style={S.label}>Tipo de Titular *</label>
          <select value={tipoTitular} onChange={e => handleTipoTitular(e.target.value)} style={S.input}>
            {TIPOS_TITULAR.map(t => <option key={t.v} value={t.v}>{t.l}</option>)}
          </select>
        </div>
      </div>

      {/* Checklist - só aparece depois de selecionar tipo imóvel */}
      {!tipoImovel ? (
        <div style={{ marginTop: 16, background: "#f8f7f4", borderRadius: 10, padding: "24px", textAlign: "center", color: "#9ca3af", fontSize: 13 }}>
          Seleciona o tipo de imóvel para gerar a lista de documentos necessários.
        </div>
      ) : (
        <div style={{ marginTop: 16 }}>
          <div style={{ display: "flex", gap: 12, marginBottom: 14, flexWrap: "wrap" }}>
            <div style={{ background: "#ecfdf5", borderRadius: 8, padding: "7px 14px", fontSize: 12.5, color: "#10b981", fontWeight: 700 }}>
              ✅ {entregues} entregues
            </div>
            <div style={{ background: emFalta > 0 ? "#fef2f2" : "#f3f4f6", borderRadius: 8, padding: "7px 14px", fontSize: 12.5, color: emFalta > 0 ? "#ef4444" : "#6b7280", fontWeight: 700 }}>
              ⚠️ {emFalta} obrigatórios em falta
            </div>
            <div style={{ background: "#f3f4f6", borderRadius: 8, padding: "7px 14px", fontSize: 12.5, color: "#6b7280", fontWeight: 600 }}>
              {itens.length} itens total
            </div>
          </div>
          <div style={{ background:"#f8f7f4", borderRadius:10, padding:"12px 14px" }}>
            {modoEditar && isLider && (
              <button onClick={()=>{ const novo = {id:"doc_"+Date.now(), label:"Novo documento", obrigatorio:true, estado:"em_falta", ficheiros:[]}; const novos=[...itens,novo]; setItens(novos); onChange(novos); }} style={{ background:"#f0fdf4", color:"#16a34a", border:"1.5px dashed #bbf7d0", borderRadius:7, padding:"5px 12px", fontSize:12, fontWeight:600, cursor:"pointer", marginBottom:10, width:"100%" }}>+ Adicionar documento</button>
            )}
            <div style={{ fontSize:11, fontWeight:700, color:"#6b7280", marginBottom:8 }}>OBRIGATÓRIOS</div>
            {itens.filter(i=>i.obrigatorio).map((item,idx)=>(
              <div key={idx} style={{ display:"flex", alignItems:"center", gap:8, padding:"5px 0", borderBottom:"1px solid #ece9e3" }}>
                <span style={{ fontSize:13 }}>📄</span>
                {modoEditar && isLider
                  ? <input value={item.label} onChange={e=>{ const n=[...itens]; n[itens.indexOf(item)]={...item,label:e.target.value}; setItens(n); onChange(n); }} style={{ ...S.inputSm, flex:1 }} />
                  : <span style={{ fontSize:12.5, color:"#374151", flex:1 }}>{item.label}</span>
                }
                {modoEditar && isLider && (
                  <button onClick={()=>{ const n=itens.filter((_,i)=>i!==itens.indexOf(item)); setItens(n); onChange(n); }} style={{ background:"none", border:"none", color:"#ef4444", cursor:"pointer", fontSize:13 }}>✕</button>
                )}
              </div>
            ))}
            {itens.filter(i=>!i.obrigatorio).length>0 && (
              <details style={{ marginTop:8 }}>
                <summary style={{ fontSize:11, color:"#9ca3af", cursor:"pointer" }}>Recomendados ({itens.filter(i=>!i.obrigatorio).length})</summary>
                {itens.filter(i=>!i.obrigatorio).map((item,idx)=>(
                  <div key={idx} style={{ display:"flex", alignItems:"center", gap:8, padding:"4px 0" }}>
                    <span style={{ fontSize:12 }}>ℹ️</span>
                    {modoEditar && isLider
                      ? <input value={item.label} onChange={e=>{ const n=[...itens]; n[itens.indexOf(item)]={...item,label:e.target.value}; setItens(n); onChange(n); }} style={{ ...S.inputSm, flex:1 }} />
                      : <span style={{ fontSize:12, color:"#6b7280", flex:1 }}>{item.label}</span>
                    }
                    {modoEditar && isLider && (
                      <button onClick={()=>{ const n=itens.filter((_,i)=>i!==itens.indexOf(item)); setItens(n); onChange(n); }} style={{ background:"none", border:"none", color:"#ef4444", cursor:"pointer", fontSize:13 }}>✕</button>
                    )}
                  </div>
                ))}
              </details>
            )}
          </div>
        </div>
      )}
      </div>}
    </div>
  );
}
